export type PrintFormat = 'A4' | 'THERMAL_80' | 'THERMAL_58'
const MOGESAPP_LOGO = '/logo_mogesapp_light.png'

export type OwnerInvoiceProfile = {
  hasActivePlan: boolean
  businessName?: string | null
  businessPhone?: string | null
  businessAddress?: string | null
  invoiceLogoUrl?: string | null
  preferredPrintFormat?: PrintFormat | null
}

export type InvoiceSellerIdentity = {
  displayName: string
  phone?: string
  address?: string
  logoUrl?: string
  showOwnerIdentity: boolean
  poweredBy: string
  printFormat: PrintFormat
}

function isPrintFormat(value: unknown): value is PrintFormat {
  return value === 'A4' || value === 'THERMAL_80' || value === 'THERMAL_58'
}

function resolvePrintFormat(preferred?: PrintFormat | null): PrintFormat {
  if (isPrintFormat(preferred)) return preferred
  return 'A4'
}

function clean(value?: string | null) {
  if (!value) return undefined
  const v = value.trim()
  return v.length > 0 ? v : undefined
}

export function resolveInvoiceSellerIdentity(
  owner: OwnerInvoiceProfile | null | undefined
): InvoiceSellerIdentity {
  const hasPlan = !!owner?.hasActivePlan

  const printFormat = resolvePrintFormat(owner?.preferredPrintFormat)

  // 🔴 CAS TRIAL → FORCÉ MOGESAPP
  if (!hasPlan) {
    return {
      displayName: 'MOGESAPP',
      logoUrl: MOGESAPP_LOGO, // fallback interne
      showOwnerIdentity: false,
      poweredBy: 'Facture générée avec MOGESAPP',
      printFormat,
    }
  }

  // 🟢 CAS ABONNÉ → BRANDING OWNER
  return {
    displayName: clean(owner?.businessName) || 'Commerce',
    phone: clean(owner?.businessPhone),
    address: clean(owner?.businessAddress),
    logoUrl: clean(owner?.invoiceLogoUrl),
    showOwnerIdentity: true,
    poweredBy: 'Propulsé par MOGESAPP',
    printFormat,
  }
}
